/** @flow */

import type { UserAccountsDetailsState } from "./types";

export const initialState: UserAccountsDetailsState = {
  requestsInProgress: 0,
  user: null,
  recentLogins: [],
  savedReports: [],
  changelog: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  assignments: [],
  modals: {
    logData: {
      visible: false,
      data: null,
    },
    editAccessLevel: {
      visible: false,
    },
    editAccountDetails: {
      visible: false,
    },
    editResetPassword: {
      visible: false,
    },
    confirmResetPassword: {
      visible: false,
    },
    editAreaAccess: {
      visible: false,
    },
    impersonate: {
      visible: false,
    },
  },
};

export default initialState;
